var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cropper"},[_c('Cropper',{ref:"cropper",attrs:{"src":_vm.config.image,"stencil-props":{
      aspectRatio: _vm.config.aspectRatio,
      maxHeight: 4,
    }}}),_c('button',{staticClass:"button is-success",class:{ 'is-loading': _vm.loading },attrs:{"type":"button"},on:{"click":_vm.updateFormCroppedImage}},[_vm._v(" "+_vm._s(_vm.translations.common.crop)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }